// $(function() {
//   console.log("READY");
// });
//
import loaderGif from "images/ajax-loader-black-trans.gif";
import spinIndicatorGif from "images/spin_indicator.gif";

export function pop_or_nav(path, host) {
  var full_path = "https://www." + host + path;
  window.open(full_path, "jango");
}

export function jSimpleBox(container_id, moving, offsetTop) {
  this.i = function (container_id, moving, offsetTop) {
    if (!$("#darkened")[0]) {
      $("#relpos").prepend($("<div/>", { id: "darkened" }));
    }
    this.overlay = $("#darkened");
    this.overlay.hide().css({ opacity: 0 });

    this.offsetTop = offsetTop;
    this.container_id = container_id;
    this.container = $("#" + this.container_id);

    this.running_back = false;

    return this;
  };
  this.callbacks = function () {
    if (
      this.container_id == "upload_song_modal" &&
      typeof _airplay.fake_up != "object"
    ) {
      _airplay.fake_up = jUploader2.i("mp3", "overlay_uploader");
    } else if (
      this.container_id == "upload_photo_modal" &&
      typeof _airplay.fake_up != "object"
    ) {
      _airplay.fake_up = jUploader2.i("picture", "overlay_uploader");
    }
  };
  this.show = function (header_copy) {
    this.callbacks();

    if (header_copy) {
      this.container.find(".banana_modal_header").html(header_copy);
      this.container.find("form").each(function (i, e) {
        $(e)[0].reset();
      });
    }

    this.overlay.css({ opacity: 0 });
    this.overlay.show();
    this.overlay.fadeTo(500, 0.3);
    this.positionme();

    $(window)
      .off("resize scroll")
      .on(
        "resize scroll",
        $.proxy(function () {
          clearTimeout($.data(this, "scrollTimer"));
          $.data(
            this,
            "scrollTimer",
            setTimeout($.proxy(this.positionme, this), 250)
          );
        }, this)
      ); //on
  };
  this.hide = function () {
    console.log("hide");
    this.container.fadeOut(300);
    this.overlay.fadeOut(300);
    $(window).off("resize scroll");
  };

  this.positionme = function () {
    this.container.show().center_fixed();
  };
  this.i(container_id);
}

export function jBox(container_id) {
  this.i = function (container_id) {
    this.container_id = container_id;
    this.container = $("#" + this.container_id);
    this.init();

    return this;
  };
  this.init = function () {
    if (!$("#darkened")[0]) {
      $("#relpos").prepend($("<div/>", { id: "darkened" }));
      $("#darkened").hide().css({ opacity: 0 });
    }
    this.first = true;
    this.overlay = $("#darkened");
    if (!this.shadowed) {
      $("#" + this.container_id).addClass("shadow");
      this.shadowed = true;
    }
    this.top_copy = "";
    this.middle_copy = "";
    this.psst_copy = "";
    this.confirm_box = $("#confirm_box");
    this.proceed_no_callback = $.proxy(this.no, this);
    this.proceed_yes_callback = $.proxy(this.go, this);
    this.yes = function () {
      return true;
    };
    this.target_form = null;
    this.box_top = $("#confirm_box_top");
    this.red_style = { backgroundColor: "#fbbfca" };
    this.green_style = { backgroundColor: "#c4ecc3" };
  };

  this.set_green = function () {
    this.box_top.css(this.green_style);
  };

  this.set_red = function () {
    this.box_top.css(this.red_style);
  };

  this.go = function (event) {
    event.stopPropagation();
    this.yes();
    if (this.target_form) {
      this.target_form.submit();
    }
    this.decouple(event);

    return false;
  };

  this.show = function () {
    this.overlay.css({ opacity: 0 });
    this.overlay.show();
    this.overlay.fadeTo(500, 0.3);
  };

  this.hide = function () {
    this.overlay.fadeOut(500);
  };

  this.boost_copy = function (pack) {
    this.top_copy =
      Translation["airplay_copy"]["you_are"] +
      " " +
      this.commify(pack.plays) +
      " " +
      Translation["airplay_copy"]["play_credits"] +
      " ($" +
      this.commify(pack.price) +
      ").";
    this.middle_copy = "";
  };

  this.change_package_copy = function (pack, copy) {
    if (copy && copy == "Renew") {
      this.top_copy =
        "You are about to Renew your $" +
        this.commify(pack.price) +
        " Package now.";
    } else {
      this.top_copy =
        Translation["airplay_copy"]["you_are2"] +
        " $" +
        this.commify(pack.price) +
        " " +
        Translation["airplay_copy"]["package_copy"];
    }
    this.psst_copy = "";
  };

  this.cancel_copy = function (cycle) {
    this.top_copy =
      cycle == 6
        ? "You are about to cancel your Unlimited Access package."
        : Translation["airplay_copy"]["you_are3"];
    this.middle_copy = $("#cancel_copy").html();
    this.psst_copy = "";
  };

  this.cancel_box = function (yescall, cycle, title) {
    this.target_form = $("#subscription_form");
    yescall =
      yescall ||
      function () {
        $("#subscription_cancel").val(true);
      };
    this.cancel_copy(cycle);
    if (title) {
      this.top_copy = title;
    }
    this.set_red();
    this.show_box(yescall);
  };
  this.set_price = function (pack) {
    $("#subscription_amount").val(pack["price"]);
  };
  this.change_box = function (pack, copy, yescall) {
    this.target_form = $("#subscription_form");
    yescall = yescall || this.set_price(pack);
    this.change_package_copy(pack, copy);
    this.set_green();
    this.show_box(yescall);
  };

  this.boost_box = function (pack, yescall) {
    this.target_form = $("#boost_form");
    yescall = yescall || function () {};
    this.boost_copy(pack);
    this.set_green();
    this.show_box(yescall);
  };
  this.show_box = function (yescall) {
    if (yescall && typeof yescall == "function") {
      this.yes = yescall;
    }
    $("#confirm_box_top").html(this.top_copy);
    $("#confirm_box_middle").html(this.middle_copy);
    if ($("#confirm_psst")[0]) {
      $("#confirm_psst").html(this.psst_copy);
    }
    this.show();

    $(window)
      .off("resize scroll")
      .on(
        "resize scroll",
        $.proxy(function () {
          clearTimeout($.data(this, "scrollTimer"));
          $.data(
            this,
            "scrollTimer",
            setTimeout($.proxy(this.positionme, this), 250)
          );
        }, this)
      ); //on

    this.positionme();
    if ($("#confirm_box_proceed")[0]) {
      var that = this;
      $("#proceed_yes")
        .off("click")
        .on("click", $.proxy(this.proceed_yes_callback, that));
      $("#proceed_no")
        .off("click")
        .on("click", $.proxy(this.proceed_no_callback, that));
    }
  };
  this.no = function (event) {
    console.log("no");
    event.stopPropagation();
    if (this.target_form) {
      this.target_form[0].reset();
    }
    if (typeof update_boost_total == "function") {
      update_boost_total();
    }
    this.decouple(event);
    return false;
  };

  this.decouple = function (event) {
    console.log("decouple");
    console.log(event);

    if (event) {
      event.stopPropagation();
    }
    this.yes = function () {
      return true;
    };
    $(window).off("resize scroll");

    $("#proceed_yes").off("click");
    $("#proceed_no").off("click");
    $("#rename_txt").val("");

    var el = "action_" + this.song_id;
    $(el).val(Translation["airplay_copy"]["select_one"]);

    this.hide();
    this.confirm_box.fadeOut(500);
    return false;
  };

  this.commify = function (str) {
    str += "";
    var x = str.split(".");
    var x1 = x[0];
    var x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return x1 + x2;
  };

  this.survey_box = function () {
    this.set_red();
    this.top_copy = Translation["airplay_copy"]["your_subscription"];
    this.psst_copy = "";
    $("#confirm_box_middle").css({ textAlign: "left" });
    this.show_box();
  };

  this.thanks = function () {
    $("#confirm_box_middle").html("");
    $("#confirm_box_top").html(Translation["airplay_copy"]["thanks"]);
    setTimeout(function () {
      if ($("#confirm_box").is(":visible")) {
        box.decouple();
      }
    }, 2000);
  };

  this.error = function (error_text, timeout) {
    this.init();
    this.set_red();
    this.top_copy = Translation["airplay_copy"]["something"];
    this.middle_copy =
      (error_text || Translation["airplay_copy"]["oops"]) +
      Translation["airplay_copy"]["please_try"];
    this.psst_copy = "";
    $("#confirm_box_middle").css({ textAlign: "center" });
    this.show_box();
    if (timeout) {
      setTimeout(function () {
        if ($("#confirm_box").is(":visible")) {
          box.decouple();
        }
      }, timeout);
    }
  };
  this.success = function (top_copy, success_text, timeout) {
    this.init();
    this.set_green();
    this.top_copy = top_copy || Translation["airplay_copy"]["thank_you"];
    this.middle_copy =
      success_text || Translation["airplay_copy"]["account_update"];
    this.psst_copy = "";
    $("#confirm_box_middle").css({ textAlign: "center" });
    this.show_box();
    setTimeout(function () {
      if ($("#confirm_box").is(":visible")) {
        box.decouple();
      }
    }, timeout || 8000);
  };
  this.cancel = function (event) {
    event.stopPropagation();
    this.decouple(event);
    return false;
  };
  this.hide_ok = function (event) {
    event.stopPropagation();
    $.ajax("/bands/" + this.band_id + "/airplay_songs/hide/" + this.song_id, {
      method: "post",
      context: this,
    }).done(function (request) {
      this.decouple();
      top.location.reload();
    });
    return false;
  };
  this.show_ok = function (event) {
    event.stopPropagation();
    $.ajax(
      "/bands/" + this.band_id + "/airplay_songs/display/" + this.song_id,
      {
        method: "post",
        context: this,
      }
    ).done(function (request) {
      this.decouple();
      top.location.reload();
    });

    return false;
  };
  this.disable_ok = function (event) {
    event.stopPropagation();
    $.ajax(
      "/bands/" + this.band_id + "/airplay_songs/disable/" + this.song_id,
      {
        method: "post",
        context: this,
      }
    ).done(function (request) {
      this.decouple(event);
      top.location.reload(); // wut - ajax submit then reload anyway?
    });
    return false;
  };
  this.rename_ok = function (event) {
    event.stopPropagation();
    $.ajax("/bands/" + this.band_id + "/airplay_songs/rename/" + this.song_id, {
      data: { song_name: this.rename },
      method: "post",
      context: this,
    }).done(function (request) {
      this.decouple();
      top.location.reload();
    });
    return false;
  };
  this.get_new_name = function () {
    name = $("#rename_txt").val();
    this.rename = name;
    $("#rename_form").hide();
    this.middle_copy =
      "Rename to <b>" +
      name +
      "</b>?<br><b>The change usually takes a few minutes.<b>";
    $("#confirm_box_middle").html(this.middle_copy);
    $("#confirm_box_proceed").show();
  };

  this.handle_action = function (value) {
    var parsed = value.split("|");
    var action = parsed[0];
    var song_id = parsed[1];
    var name = parsed[2];

    this.song_id = song_id;
    this.band_id = $("#band_id").val();
    this.init();
    this.proceed_no_callback = $.proxy(this.cancel, this);
    this.set_green();

    $("#confirm_box_proceed").show();

    if (action == "Hide") {
      $("#rename_form").hide();
      this.proceed_yes_callback = $.proxy(this.hide_ok, this);
      this.top_copy = Translation["airplay_copy"]["hide1"] + name;
      this.middle_copy =
        Translation["airplay_copy"]["ok"] +
        name +
        Translation["airplay_copy"]["will_not"];
    } else if (action == "Show") {
      $("#rename_form").hide();
      this.proceed_yes_callback = $.proxy(this.show_ok, this);
      this.top_copy = Translation["airplay_copy"]["show"] + name;
      this.middle_copy =
        Translation["airplay_copy"]["ok"] +
        name +
        Translation["airplay_copy"]["will_be"];
    } else if (action == "Rename") {
      this.song_name = $("#rename_txt").val();
      $("#confirm_box_proceed").hide();
      this.proceed_yes_callback = $.proxy(this.rename_ok, this);
      this.top_copy = Translation["airplay_copy"]["rename"] + name;
      $("#rename_form").show();
    } else if (action == "Disable") {
      $("#rename_form").hide();
      this.proceed_yes_callback = $.proxy(this.disable_ok, this);
      this.top_copy = "Delete " + name;
      this.middle_copy =
        "BE CAREFUL.<br><br>" +
        name +
        " will be deleted.<br><br><b>This change is permanent.</b><br><br>Are you super-double-extra-positive you want to DELETE this song?";
    } else {
      return;
    }

    this.show_box();
  };

  this.positionme = function () {
    this.container.show().center_fixed();
  };

  this.i(container_id);
}

/* upload song/pic iframes */
export let jUploader = {
  i: function (mode, container_id) {
    this.mode = mode;
    this.IE =
      navigator.userAgent.indexOf("MSIE ") > 0 ||
      navigator.userAgent.indexOf("Trident") > 0 ||
      navigator.userAgent.indexOf("Edge") > 0;

    this.valid_extensions =
      this.mode == "mp3"
        ? new RegExp(/mp3|m4a|wav/i)
        : new RegExp(/jpg|png|gif|jpeg/i);

    this.container = $("#" + container_id);
    this.visible_input = this.container.find(".fakefileinput");
    this.upload_button = this.container.find(".the_upload_button");
    this.choose_button = this.container.find(".the_choose_button");
    this.describe = this.container.find(".describe");

    this.file_input =
      this.mode == "mp3"
        ? $("#airplay_song_mp3")
        : this.mode == "custom_flyer"
        ? this.container.find(".airplay_overlay_image")
        : $("#airplay_picture_picture");

    this.visible_input.val("");
    this.file_input.val("");
    this.file_input.relatedElement = this.visible_input;
    if (this.mode != "custom_flyer") {
      this.upload_button.hide();
    }
    this.initFileUploads();

    this.upload_filter = this.upload_button.css("filter");
    this.upload_image = this.upload_button.css("backgroundImage");
    this.upload_dims = {
      width: this.upload_button.width(),
      height: this.upload_button.height(),
    };
    return this;
  },
  initFileUploads: function () {
    this.file_input.on("change", this.check_upload.bind(this));
    this.file_input.on("change", this.sync_vals.bind(this));

    if (this.IE) {
      this.visible_input.on("focus", this.pop_file_dialog.bind(this));
      this.choose_button.on("click", this.pop_file_dialog.bind(this));
    }
  },
  sync_vals: function () {
    $(this.file_input.relatedElement).val(
      $(this.file_input.val().split("\\")).last()[0]
    ); // dos
  },
  pop_file_dialog: function (event) {
    this.visible_input.blur();
    this.file_input.click();
    return false;
  },
  val: function () {
    return this.mode == "mp3" ? this.valsong() : this.valpic();
  },
  valsong: function () {
    var errors = [];
    if ($("#airplay_song_title").val() == "") {
      errors.push(Translation["airplay_copy"]["this_song"]);
    }
    if (
      $("#airplay_song_mp3").val() == "" ||
      !$("#airplay_song_mp3")
        .val()
        .match(/\.mp3|\.m4a|\.wav/i)
    ) {
      errors.push(Translation["airplay_copy"]["are_you"]);
    }
    var val = true;
    if (errors.length > 0) {
      val = confirm(errors.join("\n"));
    }
    return val;
  },
  unspinny: function () {
    if (this.upload_filter) {
      this.upload_button.css({ filter: this.upload_filter });
    } else {
      this.upload_button.css({
        backgroundImage: this.upload_image,
        filter: "none",
      });
    }
    this.upload_button.css({
      width: this.upload_dims.width + "px",
      height: this.upload_dims.height + "px",
    });
  },
  spinny: function () {
    if (this.mode == "custom_flyer") {
      this.upload_button.css({
        backgroundImage: `url(${loaderGif})`,
        backgroundRepeat: "no-repeat",
        border: "none",
      });
    } else {
      this.upload_button.css({
        color: "transparent",
        backgroundColor: "transparent",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        border: "none",
        backgroundImage: `url(${loaderGif})`,
      });
    }
    this.upload_button.css({ width: "20px", height: "20px", filter: "none" });
    this.upload_button.removeClass("green_button radius10");
    return true;
  },
  valpic: function () {
    var ext = this.check_extension();
    var bl = !this.file_input[0];

    if (ext === null || bl) {
      return confirm(Translation["airplay_copy"]["are_you2"]);
    } else {
      return true;
    }
  },
  check_extension: function () {
    return $($(this.file_input).val().split("."))
      .last()[0]
      .match(this.valid_extensions);
  },
  check_upload: function () {
    var ext = this.check_extension();
    var bl = !this.file_input[0];

    if (!bl && ext === null) {
      this.visible_input.addClass("error");
      if (this.describe) {
        this.describe.effect("pulsate", { times: 3 }, 2000);
        this.describe.animate({ color: "#FF0000" });
      }
    } else {
      this.visible_input.removeClass("error");
    }

    if (bl) {
      this.file_input.removeClass("shorten");
      this.choose_button.show();

      if (this.mode != "custom_flyer") {
        this.upload_button.hide();
      }
    } else {
      this.file_input.addClass("shorten");
      if (this.mode != "custom_flyer") {
        this.choose_button.hide();
      }
      this.upload_button.show();
    }

    return true;
  },
  track_it: function (event) {
    var ox = 0;
    var oy = 0;
    var elem = event.element;
    if (elem.offsetParent) {
      ox = elem.offsetLeft;
      oy = elem.offsetTop;
      while ((elem = elem.offsetParent)) {
        ox += elem.offsetLeft;
        oy += elem.offsetTop;
      }
    }
    var x = Event.pointerX(event) - ox;
    var y = Event.pointerY(event) - oy;
    var w = this.file_input.offsetWidth;
    var h = this.file_input.offsetHeight;

    this.file_input.css({ top: y - (h - 2) + "px" });
    this.file_input.css({ left: x - (w - 30) + "px" });
  },
};

export let jUploader2 = {
  i: function (mode, container_id) {
    this.mode = mode;
    this.IE =
      navigator.userAgent.indexOf("MSIE ") > 0 ||
      navigator.userAgent.indexOf("Trident") > 0 ||
      navigator.userAgent.indexOf("Edge") > 0;
    this.container = $("#" + container_id);
    this.up_form = this.container.find("form");
    this.file_input = this.up_form.find(".overlay_file");
    this.visible_input = this.up_form.find(".file_filename");
    this.choose_button = this.up_form.find(".file_action");
    this.valid_extensions =
      this.mode == "mp3"
        ? new RegExp(/mp3|m4a|wav/i)
        : new RegExp(/jpg|png|gif|jpeg/i);

    this.title_input = this.up_form.find("input.title");
    this.upload_button = this.up_form.find(".upload_submit");
    this.file_input.val("");
    this.file_input.relatedElement = this.visible_input;
    this.upload_button.addClass("inactive").prop("disabled", true);
    this.describe = this.container.prev(".describe");
    if (this.describe) {
      this.describe_style = this.describe.css("color");
    }
    this.initFileUploads();
    // _jango.fix_placeholders(container_id);
    return this;
  },
  initFileUploads: function () {
    if (this.title_input[0]) {
      this.title_input.on("keyup", this.enable_submit_button.bind(this));
    }
    this.file_input.on("change", this.check_upload.bind(this));
    this.file_input.on("change", this.sync_vals.bind(this));

    if (this.IE) {
      this.file_input.css({ width: "80px" });
      this.choose_button.css({ "padding-left": "0px", "padding-right": "0px" });
    }

    this.up_form.on("submit", this.onsubmit_check.bind(this));
  },
  onsubmit_check: function (event) {
    if (this.val()) {
      this.spinny();
      return true;
    } else {
      event.stopPropagation();
      return false;
    }
  },
  sync_vals: function () {
    var fn = $($(this.file_input).val().split("\\")).last()[0];
    this.file_input.relatedElement.html(fn); // dos
    this.enable_submit_button();
  },
  enable_submit_button: function () {
    if (
      $(this.file_input).val() != "" &&
      (!this.title_input[0] ||
        (this.title_input && this.title_input.val().replace(/\s+/g, "") != ""))
    ) {
      this.upload_button.removeClass("inactive").prop("disabled", false);
    } else {
      this.upload_button.addClass("inactive").prop("disabled", true);
    }
  },
  pop_file_dialog: function (event) {
    this.visible_input.blur();
    this.file_input.blur();
    this.file_input.click();
    return false;
  },
  val: function () {
    return this.mode == "mp3" ? this.valsong() : this.valpic();
  },
  valsong: function () {
    var errors = [];
    if (this.title_input && $(this.title_input).val() == "") {
      errors.push(Translation["airplay_copy"]["this_song"]);
    }
    if (
      $(this.file_input).val() == "" ||
      !$(this.file_input)
        .val()
        .match(/\.mp3|\.m4a|\.wav/i)
    ) {
      errors.push(Translation["airplay_copy"]["are_you"]);
    }
    if (errors.length > 0) {
      return confirm(errors.join("\n"));
    } else {
      return true;
    }
  },

  spinny: function () {
    this.upload_button.prop("disabled", true);
    this.upload_button.val("Working...");

    return true;
  },
  valpic: function () {
    var ext = this.check_extension();
    var bl = !this.file_input[0];

    if (ext === null || bl) {
      return confirm(Translation["airplay_copy"]["are_you2"]);
    } else {
      return true;
    }
  },
  check_extension: function () {
    return $($(this.file_input).val().split("."))
      .last()[0]
      .match(this.valid_extensions);
  },
  check_upload: function () {
    var ext = this.check_extension();
    var bl = !this.file_input[0];

    if (!bl && ext === null) {
      this.visible_input.addClass("error");
      if (this.describe) {
        this.describe.effect("pulsate", { times: 3 }, 2000);
        this.describe.animate({ color: "#FF0000" });
      }
    } else {
      this.visible_input.removeClass("error");
      if (this.describe) {
        this.describe.animate({ color: this.describe_style });
      }
    }

    return true;
  },
};

export function show_manage_menu(link_element) {
  $(".edit_menu").hide();
  $(link_element).prev(".menu_placement").children(".edit_menu").show();
}

export function spinny() {
  $("#submit-button").attr("src", spinIndicatorGif);
}

// the custom flyer upload hidden iframe response calls this
export function refresh_and_show_custom_flyer_box(htmlstr) {
  $("#custom_flyer_modal").replaceWith(htmlstr);
  _airplay.custom_flyer_box = new jSimpleBox("custom_flyer_modal");
  _airplay.custom_flyer_box.show();
}
export function refresh_and_show_preview(htmlstr) {
  set_overlay_style(
    airplay_overlay_display_styles[$("#airplay_overlay_preview").attr("class")]
  );
  $("#custom_flyer_modal").replaceWith(htmlstr);
  _airplay.custom_flyer_box = new jSimpleBox("custom_flyer_modal");
  _airplay.custom_flyer_box.hide();
}
